<template>
<section>
    <p><strong>{{ $t('lang.user-notice.if-youre-not-ready-to-agree-to-this') }} <a href="/faqs" target="_blank">{{ $t('lang.user-notice.heres-some-faqs-link') }}</a> {{ $t('lang.user-notice.to-help-you-decide') }}</strong></p>
    <p>{{ $t('lang.user-notice.were-introducing-a-new-channel-called-workplace') }}</p>

    <p>{{ $t('lang.user-notice.before-you-jump-right-in') }}</p>

    <h2 id="heading-1" data-magellan-target="heading-1">{{ $t('lang.user-notice.heading-1') }}</h2>

    <p>{{ $t('lang.user-notice.workplace-is-where-colleagues-can-go-to') }}</p>
    <p>{{ $t('lang.user-notice.workplace-is-where-you-can-celebrate-success') }}</p>
    <p>{{ $t('lang.user-notice.you-can-access-workplace-from-any') }}</p>
    <p>{{ $t('lang.user-notice.bt-respects-employees-rights') }}</p>
    
    <h2 id="heading-2" data-magellan-target="heading-2">{{ $t('lang.user-notice.heading-2') }}</h2>

    <p>{{ $t('lang.user-notice.we-want-everyone-to-get-involved') }}</p>
    <p>{{ $t('lang.user-notice.if-you-publish-personal-information') }}</p>
    <p>{{ $t('lang.user-notice.please-be-respectful-of-individuals') }}</p>
    <p>{{ $t('lang.user-notice.please-note-that-sharing-of-work') }}</p>
    <p>{{ $t('lang.user-notice.list-please-dont') }}</p>

    <ul class="multi-list">
      <li>{{ $t('lang.user-notice.list-share-commercially-sensitive') }}</li>
      <li>{{ $t('lang.user-notice.list-upload-legal-or-other') }}</li>
      <li>{{ $t('lang.user-notice.list-upload-contractual-documents') }}</li>
      <li>{{ $t('lang.user-notice.list-breach-copyright') }}</li>
      <li>{{ $t('lang.user-notice.list-share-posts') }}</li>
      <li>{{ $t('lang.user-notice.list-upload-or-share') }}</li>
      <li>{{ $t('lang.user-notice.list-share-any-financial') }}</li>
      <li>{{ $t('lang.user-notice.list-share-any-of-the-below') }}
        <ul>
          <li>{{ $t('lang.user-notice.list-race') }}</li>
          <li>{{ $t('lang.user-notice.list-ethnic-origin') }}</li>
          <li>{{ $t('lang.user-notice.list-politics') }}</li>
          <li>{{ $t('lang.user-notice.list-religion') }}</li>
          <li>{{ $t('lang.user-notice.list-philosophical-beliefs') }}</li>
          <li>{{ $t('lang.user-notice.list-trade-union-membership') }}</li>
          <li>{{ $t('lang.user-notice.list-genetics') }}</li>
          <li>{{ $t('lang.user-notice.list-biometrics') }}</li>
          <li>{{ $t('lang.user-notice.list-health-medical-conditions') }}</li>
          <li>{{ $t('lang.user-notice.list-sex-life') }}</li>
          <li>{{ $t('lang.user-notice.list-sexual-orientation') }}</li>
        </ul>
      </li>
    </ul>

    <p>{{ $t('lang.user-notice.please-note-if-you-are-uploading') }}</p>
    <p>{{ $t('lang.user-notice.if-youre-not-sure-dont-post-it') }}</p>


    <h2 id="heading-3" data-magellan-target="heading-3">{{ $t('lang.user-notice.heading-3') }}</h2>

    <p>{{ $t('lang.user-notice.for-the-purposes-of-implementing-workplace') }}</p>
    <p>{{ $t('lang.user-notice.bt-warrants-that-the-data-processing') }}</p>
    <p>{{ $t('lang.user-notice.bt-reserves-the-right-to-alter-this') }}</p>

    <ul>
      <li><a :href="$t('lang.user-notice.list-link-bts-acceptable-use-policy-url')" target="_blank">{{ $t('lang.user-notice.list-link-bts-acceptable-use-policy') }}</a></li>
      <li><a :href="$t('lang.user-notice.list-link-the-bt-way-url')" target="_blank">{{ $t('lang.user-notice.list-link-the-bt-way') }}</a></li>
      <li><a :href="$t('lang.user-notice.list-link-bts-data-protection-policy-url')" target="_blank">{{ $t('lang.user-notice.list-link-bts-data-protection-policy') }}</a></li>
      <li><a :href="$t('lang.user-notice.list-link-bts-employee-privacy-notice-url')" target="_blank">{{ $t('lang.user-notice.list-link-bts-employee-privacy-notice') }}</a></li>
      <li><a :href="$t('lang.user-notice.list-link-bts-disciplinary-policy-url')" target="_blank">{{ $t('lang.user-notice.list-link-bts-disciplinary-policy') }}</a></li>
      <li><a :href="$t('lang.user-notice.list-link-bts-information-classification-url')" target="_blank">{{ $t('lang.user-notice.list-link-bts-information-classification') }}</a></li>
      <li><a :href="$t('lang.user-notice.list-link-bts-our-standards-of-behaviour-url')" target="_blank">{{ $t('lang.user-notice.list-link-bts-our-standards-of-behaviour') }}</a></li>
      <li><a :href="$t('lang.user-notice.list-link-bts-social-media-policy-url')" target="_blank">{{ $t('lang.user-notice.list-link-bts-social-media-policy') }}</a></li>
    </ul>

    <p>{{ $t('lang.user-notice.please-note-that-breach-of') }}</p>

    <p> {{ $t('lang.user-notice.in-addition-to-our-own-policies') }} <a href="https://m.facebook.com/legal/FB_Work_AUP"> {{ $t('lang.user-notice.link-facebook-workplace-acceptable-use') }}</a></p>

    <h2 id="heading-4" data-magellan-target="heading-4">{{ $t('lang.user-notice.heading-4') }}</h2>

    <p>{{ $t('lang.user-notice.the-purpose-of-the-processing-of') }}</p>

    <h2 id="heading-5" data-magellan-target="heading-5">{{ $t('lang.user-notice.heading-5') }}</h2>

    <p>{{ $t('lang.user-notice.in-order-to-create-accounts') }}<p>
    <ul>
      <li>{{ $t('lang.user-notice.list-name-first-name') }}</li>
      <li>{{ $t('lang.user-notice.list-job-title') }}</li>
      <li>{{ $t('lang.user-notice.list-ouc') }}</li>
      <li>{{ $t('lang.user-notice.list-line-manager') }}</li>
      <li>{{ $t('lang.user-notice.list-work-email-address') }}</li>
      <li>{{ $t('lang.user-notice.list-work-landline-phone') }}</li>
      <li>{{ $t('lang.user-notice.list-work-mobile-phone') }}</li>
      <li>{{ $t('lang.user-notice.list-building-location-code') }}</li>
    </ul>

    <p>{{ $t('lang.user-notice.bt-will-only-be-directly-providing') }}</p> 
    <p><a href="https://intra.bt.com/bt/lgc/legal/privacy/Data%20Privacy%20Compliance%20Pages/Data%20Privacy/Pages/Data-Privacy-Policies.aspx" target="_blank">{{ $t('lang.user-notice.link-the-bt-employee-privacy-policy') }}</a> {{ $t('lang.user-notice.covers-all-the-detail-about') }}</p>

    <h2 id="heading-6" data-magellan-target="heading-6">{{ $t('lang.user-notice.heading-6') }}</h2>

    <p>{{ $t('lang.user-notice.facebook-stores-this-data-on') }}</p>
    <p>{{ $t('lang.user-notice.facebook-as-a-data-processor') }}</p>

    <ul>
      <li>{{ $t('lang.user-notice.list-spam') }}</li>
      <li>{{ $t('lang.user-notice.list-unusual-login') }}</li>
      <li>{{ $t('lang.user-notice.list-images-and-videos-containing-child') }}</li>
      <li>{{ $t('lang.user-notice.list-images-and-videos-containing-nudity') }}</li>
      <li>{{ $t('lang.user-notice.list-malware') }}</li>
      <li>{{ $t('lang.user-notice.list-dangerous-urls') }}</li>
    </ul>

    <p>{{ $t('lang.user-notice.the-above-listed-content-and-behaviour') }}</p>
    <p>{{ $t('lang.user-notice.bt-has-contractual-provisions') }}</p>
    <p>{{ $t('lang.user-notice.if-you-leave-bt') }}</p>
    <p>{{ $t('lang.user-notice.bt-may-also-share-the-data') }}</p>

    <h2 id="heading-7" data-magellan-target="heading-7">{{ $t('lang.user-notice.heading-7') }}</h2>

    <p>{{ $t('lang.user-notice.bt-has-a-lawful-basis-for-doing-so') }}</p>
    <p>{{ $t('lang.user-notice.the-legal-basis-for-the-data-processing') }}</p>

    <ul>
      <li>{{ $t('lang.user-notice.list-processing-is-necessary-for-the-purposes') }}</li>
      <li>{{ $t('lang.user-notice.list-such-interests-are-not-overridden') }}</li>
    </ul>

    <p>{{ $t('lang.user-notice.bt-completed-a-legitimate-interest-assessment') }}</p>
    <p>{{ $t('lang.user-notice.the-lia-document-is-available') }}</p>

    <h2 id="heading-8" data-magellan-target="heading-8">{{ $t('lang.user-notice.heading-8') }}</h2>

    <p>{{ $t('lang.user-notice.its-your-responsibility') }} <a href="https://hr.bt.com/pages/variationredirect.aspx?target=hr-in-bt/hr-system-updates" target="_blank"> {{ $t('lang.user-notice.link-bt-hr-system') }}</a> {{ $t('lang.user-notice.using') }} <a href="https://hr.bt.com/en-gb/hr-in-bt/hr-home-help/updating-your-personal-information" target="_blank">{{ $t('lang.user-notice.link-using-these-instructions') }}</a></p>
    <p>{{ $t('lang.user-notice.if-you-have-concerns-or-complaints') }}</p>
    <p>{{ $t('lang.user-notice.if-you-are-an-administrator') }}</p>

    <i18n path="lang.user-notice.any-questions-comments-or-complaints" tag="p">
        <a :href="'mailto:'+$t('lang.user-notice.complaint-review-legal-support-email')">{{ $t('lang.user-notice.complaint-review-legal-support-email') }}</a>
    </i18n>

    <p>{{ $t('lang.user-notice.using-the-listed-contacts') }}</p>
    <ol type="i">
      <li>{{ $t('lang.user-notice.list-access-to-their-data') }}</li>
      <li>{{ $t('lang.user-notice.list-restricition-of-the-processing') }}</li>
      <li>{{ $t('lang.user-notice.list-erasure-and-rectification') }}</li>
      <li>{{ $t('lang.user-notice.list-additionally-they-may') }}</li>
    </ol>

    <p>{{ $t('lang.user-notice.you-can-access-and-update') }}</p>
    <p>{{ $t('lang.user-notice.bt-must-respond-to-the') }}</p>
    <p>{{ $t('lang.user-notice.such-information-must-be-supplied') }}</p>
    <p>{{ $t('lang.user-notice.requests-for-remedy-and-any-complaints') }}</p>

    <h2 id="heading-9" data-magellan-target="heading-9">{{ $t('lang.user-notice.heading-9') }}</h2>
    
    <p>{{ $t('lang.user-notice.this-user-notice-is-owned') }}</p>
    <p>{{ $t('lang.user-notice.were-really-excited') }}</p>

    <h2 id="heading-10" data-magellan-target="heading-10">{{ $t('lang.user-notice.heading-10') }}</h2>

    <h3>{{ $t('lang.user-notice.hungary') }}</h3>
    <p class="no-bottom-pad">{{ $t('lang.user-notice.contact-dpo-at') }}</p>
    <i18n path="lang.user-notice.email-dpo-cee" tag="p">
        <a :href="'mailto:'+$t('lang.user-notice.email-dpo-cee-email-address')">{{ $t('lang.user-notice.email-dpo-cee-email-address') }}</a>
    </i18n>

    <p>{{ $t('lang.user-notice.hungary-employees-may-in-the-event') }}</p>

    <p class="no-bottom-pad bold">{{ $t('lang.user-notice.hungary-dpo-support') }}</p>
    <p class="no-bottom-pad">{{ $t('lang.user-notice.hungary-dpo-registered-office') }}</p>
    <p class="no-bottom-pad">{{ $t('lang.user-notice.hungary-dpo-postal-address') }}</p>
    <p class="no-bottom-pad">{{ $t('lang.user-notice.hungary-dpo-telephone') }}</p>
    <i18n path="lang.user-notice.hungary-dpo-email" tag="p" class="no-bottom-pad">
        <a :href="'mailto:'+$t('lang.user-notice.hungary-dpo-email-address')">{{ $t('lang.user-notice.hungary-dpo-email-address') }}</a>
    </i18n>
    <i18n path="lang.user-notice.hungary-dpo-website" tag="p">
        <a :href="'mailto:'+$t('lang.user-notice.hungary-dpo-website-url')">{{ $t('lang.user-notice.hungary-dpo-website-url') }}</a>
    </i18n>
  </section>
</template>
<script>
  export default {
    name: 'UserAgreementHUNGARY',
    friendlyName: "Hungary",
    title: 'Workplace user notice',
    mounted: function () {
      this.$nextTick(function () {
        this.$parent.reinitFoundation()
      })
    }
  }
</script>